// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { setDollarConversionLevels } from './dollar-conversion-level.actions';
import { resetAllCustomPdfReportItems } from '../actions';
export const securityLevelValues = createReducer([], on(setDollarConversionLevels, (state, action) => {
    return action.securityLevelValues;
}), on(resetAllCustomPdfReportItems, () => {
    return [];
}));
